import { render, staticRenderFns } from "./NoModule.vue?vue&type=template&id=1136b548"
import script from "./NoModule.vue?vue&type=script&lang=js"
export * from "./NoModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports